var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "nobox",
      style: {
        height: _vm.height,
        "padding-top": _vm.paddingTop,
        "padding-bottom": _vm.paddingBottom
      }
    },
    [_c("div", { staticClass: "desc" }, [_vm._v(_vm._s(_vm.desc))])]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76f7d638", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76f7d638","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EXNodata/index.vue
// module id = 465
// module chunks = 0